import { bloodTypes } from "utils/helpers/dictionaries";

export const bloodTypeList: bloodTypes[] = [
  bloodTypes.A, 
  bloodTypes.B,
  bloodTypes.AB,
  bloodTypes.O
]